module.exports = __webpack_public_path__ + "img/512-42dfb3.png";